import React, { useEffect, useState } from "react";

const CustomCursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isHovered, setIsHovered] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [trails, setTrails] = useState([]);

  // Google Material colors
  const googleColors = ["#4285F4", "#DB4437", "#F4B400", "#0F9D58"];

  useEffect(() => {
    const updateCursor = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });

      setTrails((prev) => {
        const newTrail = {
          x: e.clientX,
          y: e.clientY,
          id: `${Date.now()}-${Math.random()}`, // ✅ unique id
        };

        // Keep only trails younger than 500ms
        const filtered = prev.filter(
          (t) => Date.now() - parseInt(t.id.split("-")[0]) < 500
        );

        return [...filtered, newTrail].slice(-8); // max 8 points
      });
    };

    const handleMouseDown = () => setIsClicked(true);
    const handleMouseUp = () => setIsClicked(false);

    const handleHoverStart = () => setIsHovered(true);
    const handleHoverEnd = () => setIsHovered(false);

    const interactiveElements = document.querySelectorAll(
      "a, button, [role='button'], .card-hover, .modern-hover"
    );
    interactiveElements.forEach((el) => {
      el.addEventListener("mouseenter", handleHoverStart);
      el.addEventListener("mouseleave", handleHoverEnd);
    });

    document.addEventListener("mousemove", updateCursor);
    document.addEventListener("mousedown", handleMouseDown);
    document.addEventListener("mouseup", handleMouseUp);

    const trailCleanup = setInterval(() => {
      setTrails((prev) =>
        prev.filter(
          (t) => Date.now() - parseInt(t.id.split("-")[0]) < 500
        )
      );
    }, 100);

    return () => {
      document.removeEventListener("mousemove", updateCursor);
      document.removeEventListener("mousedown", handleMouseDown);
      document.removeEventListener("mouseup", handleMouseUp);
      interactiveElements.forEach((el) => {
        el.removeEventListener("mouseenter", handleHoverStart);
        el.removeEventListener("mouseleave", handleHoverEnd);
      });
      clearInterval(trailCleanup);
    };
  }, []);

  return (
    <div className="cursor-container pointer-events-none fixed top-0 left-0 w-full h-full z-[9999]">
      {/* Main cursor */}
      <div
        className={`smooth-cursor transition-transform duration-150 ease-out rounded-full
          ${isHovered ? "scale-125" : "scale-100"} ${isClicked ? "scale-75" : ""}`}
        style={{
          left: position.x - 8,
          top: position.y - 8,
          width: 16,
          height: 16,
          background: isHovered
            ? `radial-gradient(circle, ${googleColors.join(",")})`
            : "#4285F4",
          boxShadow: "0 0 8px rgba(0,0,0,0.2), 0 0 12px rgba(0,0,0,0.1)",
          position: "absolute",
        }}
      />

      {/* Trail effects */}
      {trails.map((trail, idx) => {
        // Assign color based on trail index for smooth cycling
        const color = googleColors[idx % googleColors.length];
        return (
          <div
            key={trail.id} // ✅ unique key
            className="cursor-trail-dot rounded-full"
            style={{
              left: trail.x - 4,
              top: trail.y - 4,
              width: 8,
              height: 8,
              background: color,
              opacity: ((idx + 1) / trails.length) * 0.7,
              transform: `scale(${(idx + 1) / trails.length})`,
              position: "absolute",
              pointerEvents: "none",
              transition: "all 0.2s ease-out",
            }}
          />
        );
      })}
    </div>
  );
};

export default CustomCursor;
